import React from 'react'

import ItemCardListDefault from './listDefault'
import ItemCardListBigPreview from './listBigPreview'
import ItemCardGridDefault from './gridDefault'

import ItemCardListAudio from './listAudio'
import ItemCardGridAudio from './gridAudio'

import ItemCardGridVideo from './gridVideoContainer'
import { reportVideoProgress } from '../../../../common/analytics/videoHiveAnalytics'

const ItemCard = ({
  viewType,
  videoMuted,
  itemProps,
  currentSite,
  muteVideo
}) => {
  if (viewType === 'grid') {
    if (currentSite === 'audiojungle') {
      return <ItemCardGridAudio {...itemProps} />
    } else if (currentSite === 'videohive') {
      return (
        <ItemCardGridVideo
          reportVideoProgress={reportVideoProgress}
          muted={videoMuted}
          muteVideo={muteVideo}
          {...itemProps}
        />
      )
    }

    return <ItemCardGridDefault {...itemProps} />
  }

  if (currentSite === 'audiojungle') {
    return <ItemCardListAudio {...itemProps} />
  }

  if (currentSite === 'themeforest') {
    return (
      <ItemCardListBigPreview
        {...itemProps}
        muted={videoMuted}
        muteVideo={muteVideo}
      />
    )
  }

  return (
    <ItemCardListDefault
      {...itemProps}
      muted={videoMuted}
      muteVideo={muteVideo}
    />
  )
}

export default ItemCard
